"use client";

import { useDemoTheme } from "@/context/DemoThemeContext";

export default function LoadingLogo() {
  const { logoUrl } = useDemoTheme();

  // Reserve the logo's height so surrounding content doesn't jump once it
  // loads. Never fall back to the bundled Embarca default — only the
  // partner's hero logo (from Strapi/demo picker) is allowed here.
  return (
    <div className="flex h-10 items-center justify-center">
      {logoUrl && (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={logoUrl}
          alt="Logo"
          className="h-10 w-auto max-w-[180px] object-contain"
        />
      )}
    </div>
  );
}
